import {useDispatch, useSelector} from 'react-redux'
import {Navigate, Outlet, useLocation} from 'react-router-dom'
import * as React from "react"
import {RootState} from "../../common/store"
import {notificationActions} from "../../common/store/notification.state"

export const EnrollmentsGuard = () => {
    const dispatch = useDispatch()
    const location = useLocation()

    const school = useSelector((state: RootState) => state.school)

    if(school.asd && school.badge){
        return <Outlet />
    }

    dispatch(notificationActions.warning("I dati dell'Ente Tesseramento ASD e del Codice Tessera sono obbligatori."))


    return <Navigate to="school" state={{from: location}}/>
}

